module.exports = __webpack_public_path__ + "static/img/gh_d6cd78832555_258.fc2052a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/gh_d6cd78832555_258.jpg
// module id = Jfzc
// module chunks = 1